export const SEK = 'SEK'
export const EUR = 'EUR'
export const DKK = 'DKK'

export default () => [
    { value: SEK, label: SEK },
    { value: EUR, label: EUR },
    { value: DKK, label: DKK },
]
